export const SIGNIN = '/sign-in';
export const FORGETPASSWORD = '/forgot-password';
export const TERMS = '/terminos';
export const WELCOME = '/dashboard';
export const INICIO = '/dashboard/inicio';
export const GOOGLE = '/dashboard/google';
export const NOTIFICATIONS = '/dashboard/notifications';
export const TOOLS = '/dashboard/tools';
export const POSITIONCALCULATOR = '/dashboard/tools/position-calculator';
export const MECOURSES = '/dashboard/me/courses';
export const MECOURSE = '/dashboard/me/course';
export const POSITION_CALCULATOR = '/dashboard/me/course/:id/position-calculator';
export const FORUM = '/dashboard/me/course/:id/forum';
export const USERS = '/dashboard/users';
export const COURSES = '/dashboard/courses';
export const COURSE = '/dashboard/courses/:id';
export const TEMPLATES = '/dashboard/templates';
export const REPORTS = '/dashboard/automation/reports';
export const SUBSCRIPTIONS = '/dashboard/automation/subscriptions';
export const MAILSECUENCE = '/dashboard/mailSecuence';
export const ANNOUNCEMENTDETAIL = '/dashboard/announcements';
export const DIAGNOSTIC_QUESTIONS = '/dashboard/me/course/:id/diagnostic-questions';
export const DIAGNOSTIC_ANSWERS = '/dashboard/tools/diagnostic-answers';
export const TRADING_METRICS = '/dashboard/me/course/:id/trading-metrics';
export const TRADING_METRICS_ADMIN = '/dashboard/tools/trading-metrics';
export const LIQUID_ASSETS = '/dashboard/me/course/:id/liquid-assets';
export const LIQUID_ASSETS_ADMIN = '/dashboard/tools/liquid-assets';
export const FINANCIAL_GOALS = '/dashboard/me/course/:id/financial-goals';
export const FINANCIAL_METRICS = '/dashboard/me/course/:id/financial-metrics';
export const FINANCIAL_METRICS_ADMIN = '/dashboard/tools/financial-metrics';

